import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    formGrid: {
      marginTop: 24,
      '& .MuiSvgIcon-root': { width: 18, height: 18 },
      '& .MuiTypography-body1': {
        textOverflow: 'ellipsis',
      },
    },
    buttons: {
      margin: '16px auto',

      '& .MuiButtonBase-root': {
        margin: 0,
      },
    },
    header: { marginBottom: 16 },
    headerText: { fontSize: 14 },
    statusTextField: {
      '& .MuiInputLabel-root': {
        fontWeight: 500,
        color: palette.darkGray,
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
        '&:hover fieldset': {
          border: '1px solid rgba(0, 0, 0, 0.15)',
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {},
      },
    },
    addButtonGrid: { display: 'flex', alignItems: 'center', marginLeft: 8 },
    emailField: { marginBottom: 8 },
    date: {
      marginBottom: 8,
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.borderGray,
      },
      '& .MuiFormLabel-root.Mui-error': { color: palette.insideFormGray },
    },
    dateError: {
      marginBottom: 8,
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.red,
      },
      '& .MuiFormLabel-root.Mui-error': { color: palette.red },
    },
    actionsGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '24px 0px',
    },
    seeModelsButtons: {
      color: palette.blue,
      margin: 0,
      borderColor: palette.blue,
    },
    divider: {
      width: '100%',
      marginTop: 22,
    },
    cancelButton: {
      cursor: 'pointer',
      color: palette.red,
      fontWeight: 400,
      fontSize: 12,
      textAlign: 'center',
      '&:hover': {
        fontWeight: 500,
      },
    },
    executedPublications: {
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    limitTextBold: { color: palette.deepBlue },
    limitText: { fontSize: 12 },
    executedPublicationsModal: {
      padding: '8px 0px 8px',
      display: 'flex',
      alignItems: 'center',
    },
    fieldsToFill: { paddingTop: 8 },
    helpIconForm: {
      zIndex: 2,
      color: palette.grey500,
    },
    helpIconFormServer: {
      zIndex: 2,
      color: palette.grey500,
    },
    optimizeChecks: {
      display: 'flex',
      gap: '2px',
      alignItems: 'center',
      '& .MuiFormControl-root': {
        display: 'contents',
      },
      '& .MuiGrid-root': {
        display: 'contents',
      },
    },
    blockDuration: {
      fontSize: 16,
      marginRight: 4,
    },
  });

export const styleStatus = () =>
  createStyles({
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 15,
      height: 15,
      borderRadius: '50%',
      color: palette.white,
      marginRight: 5,
    },

    blue: { backgroundColor: palette.blue },
    green: { backgroundColor: palette.green },
    orange: { backgroundColor: palette.orange },
    red: { backgroundColor: palette.red },
    gray: { backgroundColor: palette.gray },

    textOpacity: {
      fontSize: 12,
      color: palette.darkGray,
    },
    watchLaterIcon: { fontSize: 15, color: palette.dashYellow },
    loopIcon: { fontSize: 15, color: palette.skyOne.integra },
    alarmIcon: { fontSize: 15, color: palette.pink },
  });
